// Generated by scripts/theme-config/theme-config.js from api::theme-configuration. Do not edit.

export interface GeneratedProseConfig {
  /** true si el tenant subió `bulleticon`: listas de richtext con bullet SVG. */
  customBullet: boolean;
}

export const generatedProseConfig: GeneratedProseConfig = {
  "customBullet": false
};
